/**
 * O "?" do campo PharuCut na configuração das colunas do kanban.
 *
 * Nasceu de uma dúvida real (05/11): "fica em Aguardando otimização ATÉ o
 * cálculo ser aceito, ou vai para lá DEPOIS?". A resposta precisa estar
 * escrita sem margem para leitura dupla: o acontecimento TRAZ o card.
 * Os textos dos acontecimentos vêm do backend (`eventos_cut`), a mesma
 * lista do select — uma verdade só.
 */
import React from "react";

import BalaoAjuda from "../../../components/BalaoAjuda";

const maiuscula = (t) => (t ? t[0].toUpperCase() + t.slice(1) : "");

// Exemplo prático: o quadro de uma marcenaria típica (coluna → acontecimento).
const EXEMPLO = [
  ["Aguardando autorização", ""],
  ["Aguardando otimização", "sem_calculo"],
  ["Aguardando materiais", "calculo_aceito"],
  ["Aguardando corte", "liberado"],
  ["Aguardando entrega", "concluido"],
  ["Atendida", ""],
];

export default function AjudaPharuCut({ eventos }) {
  const evento = (valor) => eventos.find((e) => e.value === valor) || {};
  const rotulo = (valor) => evento(valor).label;
  const quando = (valor) => evento(valor).quando;
  const caminho = eventos.filter((e) => e.value !== "sem_calculo");
  return (
    <BalaoAjuda
      titulo="Como ligar a coluna ao PharuCut"
      rotuloGatilho="Como preencher: PharuCut"
      rotuloBalao="Ajuda: coluna ligada ao PharuCut"
      dica="Como preencher este campo"
    >
      <section>
        <h4>Em uma frase</h4>
        <p>
          Escolha o que precisa <strong>acontecer com o lote no PharuCut</strong> para
          o card <strong>vir sozinho para esta coluna</strong>. O acontecimento traz o
          card para cá: não é o que a coluna fica esperando.
        </p>
      </section>
      <section>
        <h4>Regra de bolso</h4>
        <p>
          Pergunte: <em>&ldquo;o que acabou de acontecer para o card estar nesta
          coluna?&rdquo;</em> A resposta é o que você escolhe. Se nada do PharuCut
          traz o card para cá, deixe em branco.
        </p>
      </section>
      <section>
        <h4>A ordem dos acontecimentos</h4>
        <ol>
          {caminho.map((e) => <li key={e.value}>{maiuscula(e.quando)}</li>)}
        </ol>
        <p>
          Se, a qualquer momento, {quando("sem_calculo")}, o card volta para a coluna
          ligada a isso.
        </p>
      </section>
      <section>
        <h4>Exemplo prático</h4>
        <ul>
          {EXEMPLO.map(([coluna, valor]) => (
            <li key={coluna}>
              <strong>{coluna}</strong>: {valor ? `quando o lote ${rotulo(valor)}` : "em branco"}
            </li>
          ))}
        </ul>
        <p>
          A ASM é autorizada e fica em Aguardando otimização (sem acontecimento
          nenhum ainda). O PCP otimiza e aceita o cálculo no PharuCut: o card vai
          sozinho para Aguardando materiais. O lote é liberado: vai para Aguardando
          corte. O corte termina: vai para Aguardando entrega. Atender continua sendo
          um clique de alguém.
        </p>
      </section>
      <section className="explicacao-card__atencao">
        <h4>Bom saber</h4>
        <ul>
          <li>Em branco, a coluna não muda sozinha: o card só entra e sai arrastando.</li>
          <li>Faltou coluna para um acontecimento? O card fica na do acontecimento anterior.</li>
          <li>Card com peças em vários lotes segue o lote mais atrasado.</li>
          <li>Coluna de Em andamento inicia o atendimento; coluna de Autorizada desfaz o início.</li>
          <li>O mesmo acontecimento em duas colunas: só a primeira do quadro recebe o card.</li>
          <li>Colunas de Aguardando autorização, Atendida, Recusada e Cancelada nunca recebem card do PharuCut.</li>
        </ul>
      </section>
    </BalaoAjuda>
  );
}
